<div class="modal-content">
  <div class="text-right">
    <mat-icon class="icon" (click)="closeModal()">✖</mat-icon>
  </div>

  <div class="content">
    <p class="message">Type of Report</p>
    <br>
    <div class="radio-container">
      <div class="radio-group-left">
        <label class="radio-label">
          <input type="radio" name="selectedReportType" [value]="'heat_plan'" (change)="onSelectionChange('heat_plan')" [(ngModel)]="selectedReportType">
          Heat Plan
        </label>
        <label class="radio-label">
          <input type="radio" name="selectedReportType" [value]="'tank_temp_forecast'" (change)="onSelectionChange('tank_temp_forecast')" [(ngModel)]="selectedReportType">
          Tank Temp Forecast
        </label>
        <label class="radio-label">
          <input type="radio" name="selectedReportType" [value]="'final_report'" (change)="onSelectionChange('final_report')" [(ngModel)]="selectedReportType">
          Final Report
        </label>
      </div>
      <div class="radio-group-right">
        <label class="radio-label">
          <input type="radio" name="selectedReportType" [value]="'bunker_past'" (change)="onSelectionChange('bunker_past')" [(ngModel)]="selectedReportType">
          Bunker Report - Past
        </label>
        <label class="radio-label">
          <input type="radio" name="selectedReportType" [value]="'bunker_forecast'" (change)="onSelectionChange('bunker_forecast')" [(ngModel)]="selectedReportType">
          Bunker Report - Forecast
        </label>
        <label class="radio-label">
          <input type="radio" name="selectedReportType" [value]="'avg_temp_forecast'" (change)="onSelectionChange('avg_temp_forecast')" [(ngModel)]="selectedReportType">
          Average Temp Forecast
        </label>
        <label class="radio-label">
          <input type="radio" name="selectedReportType" [value]="'report7'" (change)="onSelectionChange('report7')" [(ngModel)]="selectedReportType">
          Print Selection
        </label>
      </div>
    </div>
  </div>

  <div class="row">
    <button class="btn btn-light hover-clear clear" (click)="closeModal()">
      <span>Cancel</span>
    </button>
    <button class="btn btn-light hover-clear clear" (click)="printAndSave('print')">
      <span>Print </span>
    </button>
    <button class="btn btn-light hover-clear clear" 
          (click)="printAndSave('printAndSave')" 
          [disabled]="selectedReportType === 'report7'">
    <span>Print & Save</span>
    </button>
  </div>
</div>
